/**
 * Converts story data to zoom data
 *
 * @param {Array} storyData - story data
 * @returns {Array} - zoom data
 */
const storyZoomMapper = storyData => {
    if (!Array.isArray(storyData)) {
        return [];
    }

    return storyData.map(item => {
        const {tileImage} = item;

        // mid resolution image for lazy load
        const dataSrcUrl = new URL(tileImage.src);
        dataSrcUrl.searchParams.set('sw', 600);
        dataSrcUrl.searchParams.set('q', 100);

        // high resolution image for zoomed view
        const imageUrl = new URL(tileImage.src);
        imageUrl.searchParams.set('sw', 1600);
        imageUrl.searchParams.set('q', 100);

        return {
            src: tileImage.src,
            zoomedSrc: imageUrl.href,
            dataSrc: dataSrcUrl.href,
            width: tileImage.width,
            height: tileImage.height,
            aspectRatio: tileImage.width / tileImage.height,
            label: tileImage.alt || item.name,
            title: item.name,
            description: item.description,
            portrait: tileImage.isPortrait,
            id: item.id
        };
    });
};

export default storyZoomMapper;
